import Image from "next/image";

export function Brandmark({
  className,
  size = 40,
  quality = 100,
}: {
  className?: string;
  size?: number;
  quality?: number;
}) {
  return (
    <Image
      src="/logo.png"
      alt="Erikonomie Logo"
      width={size}
      height={size}
      quality={quality}
      className={className}
      priority
    />
  );
}
